import Entity from 'utilities/Entity';

class Block extends Entity {}

export default new Block();
